import {LocalStorageKey, setInLocalStorage} from "../localStorage";
import {useLocalStorageItem} from "./useBrowserStorage";

export const setIsKeyboardUser = (value: boolean) =>
  setInLocalStorage(LocalStorageKey.IsKeyboardUser, value);

export const useIsKeyboardUser = () => useLocalStorageItem(LocalStorageKey.IsKeyboardUser);
